export const HEALTH_CARD_TYPES = {
  ALICE: 'ALICE',
  DUQUESA: 'DUQUESA',
  CASSI: 'CASSI'
}

export const ERRORS = {
  MISSING_CASSI_MEMBERSHIP: 'missing_cassi_membership'
}
